import { AuthProvider, useAuth } from "@/auth/AuthProvider";
import { queryClient } from "@/lib/queryClient";
import { routeTree } from "@/routeTree.gen";
import { ThemeModeProvider } from "@/theme/ThemeModeProvider";
import { Box, CircularProgress } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

const router = createRouter({
  routeTree,
  context: {
    queryClient,
    // Ін'єктується в Shell компоненті нижче.
    auth: { user: null, status: "loading", role: null },
  },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
});

// Type-safe router.
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

function AppShell() {
  const auth = useAuth();

  if (auth.status === "loading") {
    // Короткий splash поки Firebase Auth + admins/{uid} резолвляться.
    return (
      <Box sx={{ minHeight: "100dvh", display: "grid", placeItems: "center" }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  return <RouterProvider router={router} context={{ queryClient, auth }} />;
}

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <ThemeModeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeModeProvider>
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error) => {
      console.warn("[pwa] service worker registration failed", error);
    });
  });
}
